"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAEnAddressDetailInput = exports.CAEnAddressInput = exports.scrollToCAAddressDetailInput = exports.CAAddressDetailInput = exports.CAAddressInput = exports.scrollToCAPostCodeInput = exports.CAPostCodeInput = exports.CANameInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
const detect_utils_1 = require("@/common/detect_utils");
const components_1 = require("@/member/setting/components");
const __1 = require("..");
/** @desc name input of DeliverySettingChangeAddress */
const CANameInput = ({ register }) => ((0, jsx_runtime_1.jsx)(components_1.SettingInput, Object.assign({ maxLength: 50, placeholder: i18next_1.default.t('이름') }, register('name', {
    required: __1.addressErrorMessages.name(),
    validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || __1.addressErrorMessages.name(),
}))));
exports.CANameInput = CANameInput;
/** @desc post_code input of DeliverySettingChangeAddress */
const CAPostCodeInput = ({ register }) => ((0, jsx_runtime_1.jsx)(components_1.SettingInput, Object.assign({ id: "ca_post_code_input", maxLength: 20, placeholder: i18next_1.default.t('우편번호') }, register('post_code', {
    required: __1.addressErrorMessages.post_code.required(),
    minLength: { value: 4, message: __1.addressErrorMessages.post_code.minLength() },
    validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || __1.addressErrorMessages.post_code.required(),
}))));
exports.CAPostCodeInput = CAPostCodeInput;
const scrollToCAPostCodeInput = () => (0, functions_1.scrollIntoCenterView)('ca_post_code_input');
exports.scrollToCAPostCodeInput = scrollToCAPostCodeInput;
/** @desc address input of DeliverySettingChangeAddress */
const CAAddressInput = ({ register }) => ((0, jsx_runtime_1.jsx)(components_1.SettingInput, Object.assign({ maxLength: 250, placeholder: i18next_1.default.t('주소') }, register('address', {
    required: __1.addressErrorMessages.address.required(),
    minLength: { value: 10, message: __1.addressErrorMessages.address.minLength() },
    validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || __1.addressErrorMessages.address.required(),
}))));
exports.CAAddressInput = CAAddressInput;
/** @desc address_detail input of DeliverySettingChangeAddress */
const CAAddressDetailInput = ({ register }) => ((0, jsx_runtime_1.jsx)(components_1.SettingInput, Object.assign({ id: "ca_address_detail_input", maxLength: 250, placeholder: i18next_1.default.t('상세주소') }, register('address_detail', {
    required: __1.addressErrorMessages.address_detail(),
    validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || __1.addressErrorMessages.address_detail(),
}))));
exports.CAAddressDetailInput = CAAddressDetailInput;
const scrollToCAAddressDetailInput = () => (0, functions_1.scrollIntoCenterView)('ca_address_detail_input');
exports.scrollToCAAddressDetailInput = scrollToCAAddressDetailInput;
/** @desc en_address input of DeliverySettingChangeAddress */
const CAEnAddressInput = ({ register }) => ((0, jsx_runtime_1.jsx)(components_1.SettingInput, Object.assign({ maxLength: 250, placeholder: i18next_1.default.t('영문 주소') }, register('en_address', {
    required: __1.addressErrorMessages.en_address.required(),
    minLength: { value: 10, message: __1.addressErrorMessages.en_address.minLength() },
    validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || __1.addressErrorMessages.en_address.required(),
}))));
exports.CAEnAddressInput = CAEnAddressInput;
/** @desc en_address_detail input of DeliverySettingChangeAddress */
const CAEnAddressDetailInput = ({ register }) => ((0, jsx_runtime_1.jsx)(components_1.SettingInput, Object.assign({ maxLength: 250, placeholder: i18next_1.default.t('영문 상세주소') }, register('en_address_detail', {
    required: __1.addressErrorMessages.en_address_detail(),
    validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || __1.addressErrorMessages.en_address_detail(),
}))));
exports.CAEnAddressDetailInput = CAEnAddressDetailInput;
